// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"24":"companies","106":"user-management","792":"main","884":"admin"}[chunkId] + "." + {"24":"03b6cb04","106":"345f0a6a","792":"f23f5051","884":"e2505818"}[chunkId] + ".css";
};